import gql from "graphql-tag"

const addCollection = gql`   
mutation 
    addOwnCollection($data: OwnCollectionInput!) {
        addOwnCollection(data: $data) 
    }
`
const removeOwnCollection = gql`
mutation 
    removeOwnCollection($collectionId: String!) {
        removeOwnCollection(collectionId: $collectionId)
    }
`
const updateOwnCollection = gql`
mutation 
    updateOwnCollection($collectionId: String!, $data: OwnCollectionInput!) {
        updateOwnCollection(collectionId: $collectionId, data: $data)
    }
`
const inviteCollectionMember = gql`
mutation 
    inviteCollectionMember($collectionId: String!, $data: MemberInvitationInput!) {
        inviteCollectionMember(collectionId: $collectionId, data: $data)
    }
`
const leaveMemberCollection = gql`
mutation 
    leaveMemberCollection($collectionId: String!) {
        leaveMemberCollection(collectionId: $collectionId)
    }
`
const removeCollectionMember = gql`
mutation
    removeCollectionMember($collectionId: String!, $email: String!) {
        removeCollectionMember(collectionId: $collectionId, email: $email)
    }
`

const addSubscribeCollection = gql`
mutation
    addSubscribeCollection($collectionId: String!) {
        addSubscribeCollection(collectionId: $collectionId)
    }
`

const leaveSubscribeCollection = gql`
mutation
    leaveSubscribeCollection($collectionId: String!) {
        leaveSubscribeCollection(collectionId: $collectionId)
    }
`

const cloneOwnCollection = gql`
mutation
    cloneOwnCollection($collectionId: String!) {
        cloneOwnCollection(collectionId: $collectionId) {
            id
        }
    }
`

const transferOwnCollection = gql`
mutation
    transferOwnCollection($collectionId: String!, $data: CollectionTransferInput!) {
        transferOwnCollection(collectionId: $collectionId, data: $data) 
    }
`

const addFavouriteHotel = gql`
mutation
    addFavouriteHotel($hotelId: String!) {
        addFavouriteHotel(hotelId: $hotelId)
    }
`

const deleteFavouriteHotel = gql`
mutation
    deleteFavouriteHotel($hotelId: String!){
        deleteFavouriteHotel(hotelId: $hotelId)
    }
`

const addFavouriteHotelToCollection = gql`
mutation
    addFavouriteHotelToCollection($hotelId: String!, $collectionId: String!) {
        addFavouriteHotelToCollection(hotelId: $hotelId, collectionId: $collectionId)
    }
`
const deleteFavouriteHotelFromCollection = gql`
mutation
    deleteFavouriteHotelFromCollection($hotelId: String!, $collectionId: String!){
        deleteFavouriteHotelFromCollection(hotelId: $hotelId, collectionId: $collectionId)
    }
`

export {
    addCollection,
    removeOwnCollection,
    updateOwnCollection,
    inviteCollectionMember,
    leaveMemberCollection,
    removeCollectionMember,
    addSubscribeCollection,
    leaveSubscribeCollection,
    cloneOwnCollection,
    transferOwnCollection,
    addFavouriteHotel,
    deleteFavouriteHotel,
    addFavouriteHotelToCollection,
    deleteFavouriteHotelFromCollection
}